<template>
  <div id='boardsContainer' style="height: 100%; width: 100%">
    <div v-if="typeOfBoard() == 1" style="width: 100%; height: 100%">
      <BoardSimple></BoardSimple>
    </div>
    <div v-else-if="typeOfBoard() == 2" style="width: 100%; height: 100%">
      <BoardDoble></BoardDoble>
    </div>
    <div v-else-if="typeOfBoard() == 3" style="width: 100%; height: 100%">
      <BoardCarrusel></BoardCarrusel>
    </div>
    <div v-else>
      <v-progress-circular :indeterminate="cargando" color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { actions } from '../store/types/smartDisplayTypes.js'
const BoardSimple = () => import('../components/BoardSimple.vue')
const BoardDoble = () => import('../components/BoardDoble.vue')
const BoardCarrusel = () => import('../components/BoardCarrusel.vue')
export default {
  components: {
    BoardSimple,
    BoardDoble,
    BoardCarrusel
  },
  data () {
    return {
      cargando: true
    }
  },
  computed: {
    ...mapState({
      smartDisplay: state => state.smartDisplays.smartDisplayList
    })
  },
  methods: {
    ...mapActions({
      getSmartDisplay: actions.GET_SMARTDISPLAY
    }),
    async initialize () {
      await this.getSmartDisplay(this.$route.params.id)
      this.resize()
    },
    typeOfBoard () {
      if (this.smartDisplay.board !== undefined) {
        this.cargando = false
        return this.smartDisplay.board.type.id
      }
    },
    resize () {
      // var heights = window.innerHeight
      // var widths = window.innerWidth
      // document.getElementById('boardsContainer').style.height = heights + 'px'
      // document.getElementById('boardsContainer').style.width = widths + 'px'
    }
  },
  created () {
    this.initialize()
  }
}
</script>
